import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import '@fontsource/archivo/600.css';
import '@fontsource/archivo/800.css';
import '@fontsource/archivo/900.css';
import './index.css';
import App from './App';
import { UserProvider } from './components/auth/AuthPage/UserContext';
import { NotificationProvider } from './contexts/NotificationContext';
import { BinderProvider } from './contexts/BinderContext';
import { MessagesProvider } from './contexts/MessagesContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <UserProvider>
        <NotificationProvider>
          <BinderProvider>
            <MessagesProvider>
              <App />
            </MessagesProvider>
          </BinderProvider>
        </NotificationProvider>
      </UserProvider>
    </BrowserRouter>
  </React.StrictMode>
);
